import { get, post, put, putFiles, putFilesProfile } from '@webapps/utils';

const { NX_REST_API, NX_PROXY_API, NX_PENNYLANE_API } = process.env;

export const getSchoolById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/schools/${id}`,
    }),
  format: ({ data }) => data,
};

export const getDegreeLevels = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/degree_levels`,
    }),
  format: ({ data }) => data,
};

export const getContractTypes = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/contract_types`,
    }),
  format: ({ data }) => data,
};

export const getContractTypesById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/module/contract_types/${id}`,
    }),
  format: ({ data }) => data,
};

export const getJobBigDomains = {
  query: () =>
    get({
      url: `${NX_REST_API}/individual/module/job_big_domains`,
    }),
  format: ({ data }) => data,
};

export const getJobSectors = {
  query: () =>
    get({
      url: `${NX_REST_API}/individual/module/job_sectors`,
    }),
  format: ({ data }) => data,
};

export const getJobSectorsByDomain = {
  query: ({ domain }) =>
    get({
      url: `${NX_REST_API}/individual/module/skills_category/big_domain/${domain}`,
    }),
  format: ({ data }) => data,
};

export const getJobsBySector = {
  query: ({ sector }) =>
    get({
      url: `${NX_REST_API}/individual/module/jobs/sector/${sector}`,
    }),
  format: ({ data }) => data,
};

export const getJobs = {
  query: ({ keyword, sector, size, page }) =>
    get({
      url: `${NX_REST_API}/jobs/search?keyword=${keyword}`,
      options: {
        params: {
          ...(sector && { sector }),
          ...(size && { size }),
          ...(page && { page }),
        }
      },
    }),
  format: ({ data }) => data,
};

export const getJobsDomains = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/domains`,
    }),
  format: ({ data }) => data,
};

export const getJobsById = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/jobs/${id}`,
    }),
  format: ({ data }) => data,
};

export const getSkillsByJobOgr = {
  query: ({ jobOgr }) =>
    get({
      url: `${NX_REST_API}/individual/module/job_sector_skills/ogr/${jobOgr}`,
    }),
  format: ({ data }) => data,
};

export const getAllAvantages = {
  query: () =>
    get({
      url: `${NX_REST_API}/jobs/module/job_advantages`,
    }),
  format: ({ data }) => data,
};

export const updateCoverImage = {
  query: ({ data, id }) =>
    putFiles({
      url: `${NX_REST_API}/profile/update/cover_picture/${id}`,
      data,
    }),
};

export const updateProfileImage = {
  query: ({ data, id }) =>
    putFilesProfile({
      url: `${NX_REST_API}/profile/update/profile_picture/${id}`,
      data,
    }),
};

export const getInfoAttachment = {
  query: ({ id }) =>
    get({
      url: `${NX_REST_API}/affiliates/attachments/${id}`,
    }),
  format: ({ data }) => data,
};

export const registerNewsLetter = {
  query: ({ email }) =>
    post({
      url: `${NX_REST_API}/accounts/newsletters/subscribers?email=${email}`,
    }),
};

export const getListNewsletter = {
  query: ({ keyword, page, size }) =>
    get({
      url: `${NX_REST_API}/accounts/newsletters/subscribers?email=${keyword}&page=${page}&size=${size}`,
    }),
  format: ({ data }) => data,
};

export const getInfoAccountByAlias = {
  query: ({ alias }) =>
    get({
      url: `${NX_REST_API}/accounts/alias/${alias}`,
    }),
  format: ({ data }) => data,
};

export const getNotifications = {
  query: ({ id, page, size, status }) =>
    get({
      url: `${NX_REST_API}/notifications/${id}?page=${page}&size=${size}&status=${status}`,
    }),
  format: ({ data }) => data,
};

export const setNotificationsStatus = {
  query: ({ id }) =>
    put({
      url: `${NX_REST_API}/notifications/${id}/read`,
    }),
  format: ({ data }) => data,
};

export const updateTutorialState = {
  query: ({ id, state }) =>
    put({
      url: `${NX_REST_API}/profile/tutorial/${id}?state=${state}`,
    })
}
export const getAllInvoices = {
  query: () =>
    get({
      url: `${NX_PENNYLANE_API}/billing/invoices`,
    }),
  format: ({ data }) => data,
}

export const getUserInvoices = {
  query: ({ id }) =>
    get({
      url: `${NX_PROXY_API}/getCustomerInvoices/${id}`,
    }),
  format: ({ data }) => data,
}

export const getNewMessages = {
  query: ({ to }) =>
    get({
      url: `${NX_REST_API}/accounts/messages/new?to=${to}`,
    }),
  format: ({ data }) => data,
}

export const sendNewMessage = {
  query: ({ to, from, message }) =>
    post({
      url: `${NX_REST_API}/accounts/messages/new?to=${to}&from=${from}&message=${message}`,
    }),
}

export const readNewMessages = {
  query: ({ to, from }) =>
    put({
      url: `${NX_REST_API}/accounts/messages/read?to=${to}&from=${from}`,
    }),
}

export const getPartnership = {
  query: ({ schoolId, businessId }) =>
    get({
      url: `${NX_REST_API}/partners/${schoolId}/${businessId}`,
    }),
  format: ({ data }) => data,
}

export const addCommentToPartnership = {
  query: ({ schoolId, businessId, data }) =>
    put({
      url: `${NX_REST_API}/partners/${schoolId}/${businessId}/comment`,
      data,
    }),
}

export const getInviteExternal = {
  query: ({ id, from }) =>
    get({
      url: `${NX_REST_API}/invites/external/${id}?from=${from}`,
    }),
  format: ({ data }) => data,
}

export const consumeInviteExternal = {
  query: ({ id, action, job }) =>
    put({
      url: `${NX_REST_API}/invites/external/${id}?action=${action}`,
      options: {
        params: {
          ...(job ? { job } : {}),
        },
      },
    }),
  format: ({ data }) => data,
}

export const getOpcoRecord = {
  query: ({ id, from }) =>
    get({
      url: `${NX_REST_API}/cfa/opco/record/${from}/${id}`,
    }),
  format: ({ data }) => data,
}

export const getContractToSign = {
  query: ({ id, from }) =>
    get({
      url: `${NX_REST_API}/cfa/contracts/sign/${from}/${id}`,
    }),
  format: ({ data }) => data,
}
